export default "__VITE_ASSET__f0e3aec9__"